import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import logo from '../../assets/images/logocargo.png';
import { withRFSToken } from '../../Services/axios.js';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faImage } from '@fortawesome/free-solid-svg-icons';
const RfsTimeTracker = () => {

  const isMounted = useRef(false);
  const [allDAta, setAllData] = useState([]);
  const [isAvailable, setIsAvailable] = useState(false);

  const loadDetails = async (tracker) => {
    try {
      const res = withRFSToken.post('external-loding-time-data', { 'time_tracker': tracker })
        .then(function (res) {
          if (res.data.response_code == 200) {
            setAllData({
              ...res.data.response_data,
              time_tracker: tracker
            });
            setIsAvailable(true)
          }else{
            setIsAvailable(false)
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    const tracker = localStorage.getItem('TTRACKER');
    if (tracker) {
      loadDetails(tracker)
      // const res = withRFSToken.post('external-loding-time-data', { 'time_tracker': tracker })
      //   .then(function (res) {
      //     if (res.data.response_code == 200) {
      //       setAllData({
      //         ...res.data.response_data,
      //         time_tracker: tracker
      //       });
      //     }
      //   });
    }
  }, []);
  // const updateTime = async () => {
  //   try {
  //     const res = await withRFSToken.post('external-loding-time-set', allDAta)
  //       .then(function (res) {
  //         if (res.data.response_code == 200) {
  //           toast.success(res.data.response_msg)
  //           setTimeout(() => {
  //             window.location.reload();              
  //           }, 2000);
  //         }
  //       });
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  const updateTime = async () => {
  try {
    // Filter only the newly uploaded attachments (which have base64 data)
    const newAttachments = (allDAta.attachments || []).filter(att => att.base64);

    // Prepare data with only new attachments
    const payload = {
      ...allDAta,
      attachments: newAttachments
    };
    if(allDAta.date_time && allDAta.user_name){
      const res = await withRFSToken.post('external-loding-time-set', payload);
      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }else{
        toast.error(res.data.response_msg);
      }
    }else{
      toast.error("Please provide user name and date time");
    }
    
  } catch (error) {    console.error('Error updating time:', error);
  }
};

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (file.size > 26214400) {
          toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
          return;
        }
        const fileObj = {
          base64: reader.result,
          file_name: file.name,
          primary: 1
        };
        setAllData((prevData) => {
          const existingAttachments = prevData.attachments || [];
          return {
            ...prevData,
            attachments: [...existingAttachments, fileObj]
          };
        });
      };
      reader.readAsDataURL(file);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAllData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRemoveAttachment = (indexToRemove) => {
    setAllData((prevData) => {
      const updatedAttachments = prevData.attachments.filter((_, index) => index !== indexToRemove);
      return {
        ...prevData,
        attachments: updatedAttachments
      };
    });
  };
  return (
    <>
      <div className='qr_code_page'>
        <Row>
          <Col className='text-center'>
            <img alt='CARGOHUB' className='my-4' src={logo} />
            <h4>{allDAta?.request_type === 'start_loading' ? 'Start Loading' : 'End Loading'}</h4>
            <p>Please Set {allDAta?.request_type === 'start_loading' ? 'Start Loading' : 'End Loading'}</p>
            {isAvailable==true ? (
              <>
                <div className='my-4'>
                  <Form.Group className="my-2" controlId="exampleForm.ControlInput1">
                    <input
                      type="text"
                      name="user_name"
                      className='form-control'
                      placeholder="User Name"
                      value={allDAta?.user_name}
                      onChange={handleChange}
                      disabled={!!allDAta?.date_time}
                    />
                  </Form.Group>

                  <Form.Group className="my-2" controlId="exampleForm.ControlInput1">
                    <input
                      type="datetime-local"
                      name="date_time"
                      className='form-control'
                      placeholder="Office In"
                      value={allDAta?.date_time}
                      onChange={handleChange}
                      disabled={!!allDAta?.date_time}
                    />
                  </Form.Group>
                </div>

                <Row>
                  <Col xs={6}>

                    <div className="upload-btn-wrapper">
                      <button className="btn"><FontAwesomeIcon icon={faCamera} /> Open Camera </button>
                      <input
                        type="file"
                        name="myfile"
                        accept="image/*"
                        capture="environment"
                        onChange={handleFileChange}

                      />
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="upload-btn-wrapper">
                      <button className="btn"><FontAwesomeIcon icon={faImage} /> Open Gallery </button>
                      <input
                        type="file"
                        name="myfile"
                        accept="image/*"
                        onChange={handleFileChange}
                        multiple
                      />
                    </div>
                  </Col>
                </Row>
                <div>
                  {allDAta?.attachments && allDAta.attachments.length > 0 && (
                    <Row className="mt-3">
                      {allDAta.attachments.map((file, index) => (
                        <Col md={4} xs={3} key={index} className="position-relative mb-2">
                          <img
                            src={file.base64 || file.file_path}
                            alt={file.file_name}
                            className="img-thumbnail"
                            style={{ height: '80px', objectFit: 'cover', width: '100%' }}
                          />
                          {(!allDAta?.date_time || file.base64) && (
                            <Button
                              variant="danger"
                              size="sm"
                              className='qr_close'
                              onClick={() => handleRemoveAttachment(index)}
                            >
                              &times;
                            </Button>
                          )}
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>
                <Row>
                  <Col>
                    <Button variant="primary w-100 mt-4" onClick={updateTime}>
                      Save
                    </Button>
                  </Col>
                </Row>
              </>
            ): (
              <>
                <p className='mt-5'>Please provide start Loading Data First</p>
              </>
            )}
              
          </Col>
        </Row>
      </div>
    </>
  )
}

export default RfsTimeTracker
